import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { getClass, viewSubject, toggleSubject, deleteSubject } from '~/services/api'
import { SubjectDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    subject: Array,
    data: Array,
    loading: Boolean,
    description: String,
    classes: Array,
    subject_type: integer,
    extra_data: string,
}

export class AbstractSubjectViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            description: '',
            subject_type: null,
            class_id: this.props.match.params.id,
            classes: null,
            subject: [
                {
                    subject: {
                        field: 'text',
                        translate: 'classes:subject.title',
                        route: false,
                        sortable: true,
                    },
                    code: {
                        field: 'text',
                        translate: 'classes:subject.add.codeLabel',
                        route: false,
                        sortable: true,
                    },
                    // weekly_classes: {
                    //     field: 'text',
                    //     translate: "classes:subject.add.weeklyClassesLabel",
                    //     route: false,
                    //     sortable: true,
                    // },
                    // credit_hour: {
                    //     field: 'text',
                    //     translate: "classes:subject.add.crHourLabel",
                    //     route: false,
                    //     sortable: true,
                    // },
                    status: {
                        field: 'badge',
                        translate: 'status',
                        route: false,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        translate: 'classes:subject.action',
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this._handleChange = this._handleChange.bind(this)
        this.toggle = this.toggle.bind(this)
        this.delSubject = this.delSubject.bind(this)
    }

    componentDidMount() {
        this.loadSubject()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        toggleSubject(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadSubject()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    delSubject(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        deleteSubject(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadSubject()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadSubject() {
        this._handleChange('loading', true)
        let classes = null
        getClass(this.state.class_id, this.props.token).then((response) => {
            this._handleChange('loading', false)
            // let subject = [];
            // subject.push(this.state.subject[0]);
            let dataList = []
            if (response.code == API_SUCCESS) {
                classes = response.data.class
            } else {
                toastMessage('error', response.message)
            }
        })
        viewSubject(this.state.class_id, this.props.token).then((response) => {
            this._handleChange('loading', false)
            let subject = []
            // let classes = null;
            subject.push(this.state.subject[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                // classes=response.data.class;
                response.data.subject.map((item, index) => {
                    const data: SubjectDTO = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            translate: 'statusActive',
                            badge: 'table-green',
                            modal: 'modal_class_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            translate: 'statusInactive',
                            badge: 'table-red',
                            modal: 'modal_class_' + index,
                        }
                    }
                    const tableData = {
                        subject: {
                            text: data.name,
                        },
                        code: {
                            text: data.code,
                        },
                        // weekly_classes: {
                        //     text: data.weekly_classes,
                        // },
                        // credit_hour: {
                        //     text: data.credit_hour,
                        // },
                        status: text,
                        action: {
                            text: 'Edit',
                            translate: 'EditBtn',
                            route: route.admin.school.subject.edit + '/' + data.id + '/' + this.state.class_id,
                        },
                    }
                    dataList.push(data)
                    subject.push(tableData)
                })
            } else {
                toastMessage('error', response.message)
            }
            this.setState({
                data: dataList,
                subject,
                classes,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
